/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-23, 15:45:35
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import * as filters from './filters';

Object.keys(filters)
  .forEach(filter => Vue.filter(filter, filters[filter]));



// WEBPACK FOOTER //
// ./src/filters/index.js